// Dependencies
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './allowance-creation.scss';

// Utils
import { ALLOWANCE_NOT_APPROVED, ALLOWANCE_REQUEST_MAX_DAYS, ALLOWANCE_TYPE_MEAL_TRAVEL, ALLOWANCE_TYPE_PRESENCE_TICKET, UNIT_KM_VALUE } from '../../../common/constants';

// Primereact imports
import { Steps } from 'primereact/steps';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';

// Services
import PaymentService from '../../../redux/services/payment';
import AllowanceService from '../../../redux/services/allowance';
import { ALLOWANCE_DEFAULT_REGION, ALLOWANCE_REGIONS } from '../../../common/lists/allowance';
import { dayDiff, getUTCDate } from '../../../common/utils/date-utils';

class AllowanceCreationComponent extends Component {

   constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            organicUnits: [],
            selectedAllowanceType: null,
            selectedAllowance: null,
            dialogSteps: [
                { label: this.props.t("allowances.dialog.tabs.step-1"), command: null },
                { label: this.props.t("allowances.dialog.tabs.step-2"), command: null },
                { label: this.props.t("allowances.dialog.tabs.step-3"), command: null }
            ],
            dialogActiveIndex: 0,
            hasCheckpoint: false,
            iban: "",
            place: "",
            departurePlace: "",
            checkpointPlace: "",
            allowanceRegion: ALLOWANCE_DEFAULT_REGION,
            beginDate: null,
            endDate: null,
            reason: "",
            presenceTicketType: 0,
            validIban: true,
            hasIban: true,
            hasNiss: true,
            hasDeparturePlace: true,
            hasPlace: true,
            hasBeginDate: true,
            hasEndDate: true,
            validDates: true,
            validPeriod: true,
            validLastYearProcess: true,
            validDelayedProcess: true,
            hasReason: true,
            hasMeeting: true,
            hasOrganicUnit: true,
            hasPresenceTicketType: true,
            selectedMeeting: null,
            selectedOrganicUnit: null,
            selectedOrganicUnitOption: null,
            travelTypes: [],
            // Travel parameters
            travelType: { key: 0 },
            representation: false,
            hasHotel: false,
            hotelName: "",
            hotelStars: "",
            hotelPrice: "",
            hotelTotal: null,
            hotelPhone: "",
            hasMeal: false,
            hasMealNumber: true,
            mealNumber: "",
            startPeriodDate: null,
            startPeriodHour: null,
            returnPeriodDate: null,
            returnPeriodHour: null,
            busTravel: false,
            busStartValue: "",
            busEndValue: "",
            trainTravel: false,
            trainStartValue: "",
            trainEndValue: "",
            carTravel: false,
            carPlate: "",
            carKm: "",
            taxiTravel: false,
            taxiStartValue: "",
            taxiEndValue: "",
            planeTravel: false,
            planeStartValue: "",
            planeEndValue: "",
            observations: "",
            hasTravelType: true,
            hasHotelOrMeal: true,
            hasHotelName: true,
            hasHotelStars: true,
            hasHotelPrice: true,
            hasHotelPhone: true,
            hasStartPeriodDate: true,
            hasStartPeriodHour: true,
            hasReturnPeriodDate: true,
            hasReturnPeriodHour: true,
            validPeriodDates: true,
            hasTransport: true,
            hasBusStartValue: true,
            hasBusEndValue: true,
            hasTrainStartValue: true,
            hasTrainEndValue: true,
            hasCarPlate: true,
            hasCarKm: true,
            hasTaxiStartValue: true,
            hasTaxiEndValue: true,
            hasPlaneStartValue: true,
            hasPlaneEndValue: true
        };
    }
    
    componentDidMount() {
        if(this.props.associate !== null) {
            this.setState({
                iban: this.props.associate.personalData.iban
            });
        }

        if(this.props.organicUnits !== null && this.props.organicUnits.length === 1) {
            this.setState({
                selectedOrganicUnit: this.props.organicUnits[0],
                selectedOrganicUnitOption: this.props.organicUnits[0],
                presenceTicketType: this.props.organicUnits[0].presenceTicketType,
                travelTypes: this.getTravelTypes(this.props.organicUnits[0])
            });
        }

        if(this.props.associate.professionalData !== undefined && this.props.associate.professionalData !== null) {
            if(this.props.associate.professionalData.fullAddress !== null && this.props.associate.professionalData.cP4 !== null && this.props.associate.professionalData.cP3 !== null && this.props.associate.professionalData.city !== null) {
                this.setState({
                    departurePlace: this.props.associate.professionalData.fullAddress + " " + this.props.associate.professionalData.cP4 + "-" + this.props.associate.professionalData.cP3 + " " + this.props.associate.professionalData.city
                });
            }
            else {
                this.setState({
                    departurePlace: this.getPersonalAddress() + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city
                });
            }
        }
        else {
            this.setState({
                departurePlace: this.getPersonalAddress() + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city
            });
        }

        // Update scenarios       
        if(this.props.selectedAllowance !== null && this.props.selectedAllowanceType === ALLOWANCE_TYPE_MEAL_TRAVEL) {
            for (let i = 0; i < this.props.organicUnits.length; i++) {
                if(this.props.selectedAllowance.organicUnitId === this.props.organicUnits[i].id) {
                    this.setState({
                        selectedOrganicUnit: this.props.organicUnits[i],
                        selectedOrganicUnitOption: this.props.organicUnits[i],
                        presenceTicketType: this.props.organicUnits[i].presenceTicketType,
                        travelTypes: this.getTravelTypes(this.props.organicUnits[i])
                    });
                }
            }

            this.setState({
                place: this.props.selectedAllowance.eventPlace,
                departurePlace: this.props.selectedAllowance.departurePlace,
                checkpointPlace: this.props.selectedAllowance.checkpointPlace,
                hasCheckpoint: this.props.selectedAllowance.checkpointPlace !== "",
                beginDate: new Date(this.props.selectedAllowance.eventBeginDate),
                endDate: new Date(this.props.selectedAllowance.eventEndDate),
                startPeriodDate: new Date(this.props.selectedAllowance.allowanceTravelMealHotel.beginDate),
                returnPeriodDate: new Date(this.props.selectedAllowance.allowanceTravelMealHotel.endDate),
                startPeriodHour: new Date(this.props.selectedAllowance.allowanceTravelMealHotel.beginDate),
                returnPeriodHour: new Date(this.props.selectedAllowance.allowanceTravelMealHotel.endDate),
                reason: this.props.selectedAllowance.reason,
                observations: this.props.selectedAllowance.observations,
                travelType: this.props.selectedAllowance.allowanceTravelMealHotel.payment ? { key: 1 } : { key: 2 },
                busTravel: this.props.selectedAllowance.allowanceTravelMealHotel.bus,
                busStartValue: this.props.selectedAllowance.allowanceTravelMealHotel.busPrice,
                busEndValue: this.props.selectedAllowance.allowanceTravelMealHotel.busReturnPrice,
                trainTravel: this.props.selectedAllowance.allowanceTravelMealHotel.train,
                trainStartValue: this.props.selectedAllowance.allowanceTravelMealHotel.trainPrice,
                trainEndValue: this.props.selectedAllowance.allowanceTravelMealHotel.trainReturnPrice,
                taxiTravel: this.props.selectedAllowance.allowanceTravelMealHotel.taxi,
                taxiStartValue: this.props.selectedAllowance.allowanceTravelMealHotel.taxiPrice,
                taxiEndValue: this.props.selectedAllowance.allowanceTravelMealHotel.taxiReturnPrice,
                planeTravel: this.props.selectedAllowance.allowanceTravelMealHotel.plane,
                planeStartValue: this.props.selectedAllowance.allowanceTravelMealHotel.planePrice,
                planeEndValue: this.props.selectedAllowance.allowanceTravelMealHotel.planeReturnPrice,
                carTravel: this.props.selectedAllowance.allowanceTravelMealHotel.car,
                carPlate: this.props.selectedAllowance.allowanceTravelMealHotel.carPlate,
                carKm: this.props.selectedAllowance.allowanceTravelMealHotel.carKms,
                carTotal: this.props.selectedAllowance.allowanceTravelMealHotel.carKms !== "" ? (this.props.selectedAllowance.allowanceTravelMealHotel.carKms * UNIT_KM_VALUE).toFixed(2) : null,
                hasMeal: this.props.selectedAllowance.allowanceTravelMealHotel.meal,
                mealNumber: this.props.selectedAllowance.allowanceTravelMealHotel.mealNumber,
                hasHotel: this.props.selectedAllowance.allowanceTravelMealHotel.hotel,
                hotelName: this.props.selectedAllowance.allowanceTravelMealHotel.hotelName,
                hotelStars: this.props.selectedAllowance.allowanceTravelMealHotel.numStars,
                hotelPrice: this.props.selectedAllowance.allowanceTravelMealHotel.dailyPrice,
                hotelTotal: this.props.selectedAllowance.eventBeginDate !== null && this.props.selectedAllowance.eventBeginDate !== null ? dayDiff(new Date(this.props.selectedAllowance.eventBeginDate), new Date(this.props.selectedAllowance.eventEndDate)) > 0 ? Number(this.props.selectedAllowance.allowanceTravelMealHotel.dailyPrice) * dayDiff(new Date(this.props.selectedAllowance.eventBeginDate), new Date(this.props.selectedAllowance.eventEndDate)) : null : null,
                hotelPhone: this.props.selectedAllowance.allowanceTravelMealHotel.telephoneNumber
            })
        }
    }

    getTravelTypes(organicUnit) {
        return [
            { name: this.props.t("allowances.dialog.travel-hotel-meal.travel-type-1"), key: 1, description: this.props.t("allowances.dialog.travel-hotel-meal.travel-type-description-1"), disabled: !(organicUnit && organicUnit.allowExpenseSubmission) },
            { name: this.props.t("allowances.dialog.travel-hotel-meal.travel-type-2"), key: 2, description: this.props.t("allowances.dialog.travel-hotel-meal.travel-type-description-2"), disabled: !(organicUnit && organicUnit.allowPayments) },
        ];
    }

    componentDidUpdate(prevProps) {       
        if (this.props.organicUnits !== prevProps.organicUnits) {
            if(this.props.organicUnits !== null && this.props.organicUnits.length === 1) {
                this.setState({
                    selectedOrganicUnit: this.props.organicUnits[0],
                    selectedOrganicUnitOption: this.props.organicUnits[0],
                    presenceTicketType: this.props.organicUnits[0].presenceTicketType,
                    travelTypes: this.getTravelTypes(this.props.organicUnits[0])
                });
            }
        }
    }

    getOrganicUnitList() {
        let organicUnits = [];

        if(this.props.organicUnits !== undefined && this.props.organicUnits !== null) {
            for (let i = 0; i < this.props.organicUnits.length; i++) {
                organicUnits.push({ name: this.props.organicUnits[i].name, code: this.props.organicUnits[i].id })
            }
        }

        return organicUnits;
    }

    selectOrganicUnit(organicUnit) {
        for (let i = 0; i < this.props.organicUnits.length; i++) {
            if(this.props.organicUnits[i].id === organicUnit.code) {
                this.setState({
                    selectedOrganicUnit: this.props.organicUnits[i],
                    presenceTicketType: this.props.organicUnits[i].presenceTicketType,
                    selectedOrganicUnitOption: organicUnit,
                    travelTypes: this.getTravelTypes(this.props.organicUnits[i])
                });
            }
        }
    }

    getMeetingList() {
        let meetings = [];

        if(this.props.meetings !== undefined && this.props.meetings !== null) {
            for (let i = 0; i < this.props.meetings.length; i++) {

                if(this.state.selectedOrganicUnit.id === this.props.meetings[i].organicUnitId) {
                    meetings.push({ name: this.props.meetings[i].title, code: this.props.meetings[i].meetingId });
                }
            }
        }

        return meetings;
    }

    selectMeeting(meeting) {
        this.setState({ selectedMeeting: meeting});

        for (let i = 0; i < this.props.meetings.length; i++) {
            if(this.props.meetings[i].meetingId === meeting.code) {
                this.setState({
                    place: this.props.meetings[i].place,
                    reason: this.props.meetings[i].title,
                    beginDate: new Date(this.props.meetings[i].meetingDate),
                    endDate: new Date(this.props.meetings[i].meetingDate)
                });
            }
        }
    }

    getPresenceTicketTypes() {
        let presenceTicketTypes = [];

        for (let i = 0; i < this.props.presenceTicketTypes.length; i++) {
            presenceTicketTypes.push({
                name: this.props.presenceTicketTypes[i].presenceTicketType === 1 ?
                    this.props.t("allowances.dialog.presence-tickets.type-1").replace("{0}", this.props.presenceTicketTypes[i].price)
                    :
                    this.props.t("allowances.dialog.presence-tickets.type-2").replace("{0}", this.props.presenceTicketTypes[i].price),
                key: this.props.presenceTicketTypes[i].presenceTicketType
            }); 
        }
        return presenceTicketTypes;
    }

    updateDialogActiveIndex(dialogIndex) {
        this.setState({
            dialogActiveIndex: dialogIndex
        });
    }

    validateFormAndSubmitStep() {
        if(this.state.dialogActiveIndex === 0) {
            if(this.state.selectedOrganicUnitOption === null) {
                this.setState({
                    hasOrganicUnit: false
                });
            }
            else {
                this.setState({
                    hasOrganicUnit: true
                });

                this.updateDialogActiveIndex((this.state.dialogActiveIndex+1));
            }
        }
        else if(this.state.dialogActiveIndex === 1) {
            if(this.props.associate.personalData.niss === null || this.props.associate.personalData.niss === "") {
                this.setState({
                    hasNiss: false
                });
            }

            if(this.state.iban === null || this.state.iban === "") {
                this.setState({
                    hasIban: false
                });
            }
            else {
                if(this.props.associate.personalData.niss !== null && this.props.associate.personalData.niss !== "") {
                    PaymentService.validateIBAN(this.state.iban.replace(' ','')).then((response) => { 
                        this.setState({
                            validIban: response
                        });
    
                        if(response === true) {
                            this.updateDialogActiveIndex((this.state.dialogActiveIndex+1));
                        }
                    });
                }
            }
        }
        else if(this.state.dialogActiveIndex === 2) {
            this.setState({
                hasPlace: this.state.place !== "",
                hasDeparturePlace: this.state.departurePlace !== "",
                hasMeeting: this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET ? this.state.selectedMeeting !== null : true,
                hasBeginDate: this.state.beginDate !== null,
                hasEndDate: this.state.endDate !== null,
                validDates: (this.state.beginDate === null || this.state.endDate === null || this.state.endDate >= this.state.beginDate),
                hasReason: this.state.reason !== "",
            });

            let validAllowance = (this.state.place !== "" && this.state.beginDate !== null && this.state.endDate !== null && this.state.endDate >= this.state.beginDate && this.state.reason !== "");

            if(validAllowance) {
                var currentDate = getUTCDate(new Date());

                if(getUTCDate(this.state.beginDate).getFullYear() < currentDate.getFullYear())  {
                    if(currentDate > new Date(currentDate.getFullYear(), 1, 10)) {
                        validAllowance = false;

                        this.setState({
                            validLastYearProcess: false,
                            validDelayedProcess: true
                        });
                    }
                    else {
                        this.setState({
                            validLastYearProcess: true,
                            validDelayedProcess: true
                        });
                    }
                }
                else {
                    if(dayDiff(getUTCDate(this.state.beginDate), currentDate) > ALLOWANCE_REQUEST_MAX_DAYS) {
                        validAllowance = false;

                        this.setState({
                            validLastYearProcess: true,
                            validDelayedProcess: false
                        });
                    }
                    else {
                        this.setState({
                            validLastYearProcess: true,
                            validDelayedProcess: true
                        });
                    }
                }
            }

            if(validAllowance) {
                let allowance = {
                    organicUnitId: this.state.selectedOrganicUnit.id,
                    allowanceTypeId: this.props.selectedAllowanceType,
                    associateId: this.props.associate.associateId,
                    iban: this.state.iban,
                    ballotRef: this.props.ballot !== null ? this.props.ballot.ballotRef : null,
                    departurePlace: this.state.departurePlace,
                    checkpointPlace: this.state.checkpointPlace,
                    eventPlace: this.state.place,
                    eventBeginDate: getUTCDate(this.state.beginDate),
                    eventEndDate: getUTCDate(this.state.endDate),
                    reason: this.state.reason,
                    observations: this.state.observations,
                    representation: this.state.representation
                };

                if(!this.props.creationMode) {
                    allowance.allowanceRef = this.props.selectedAllowance.allowanceRef;
                }

                let validPeriod = true;
            
                if(this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET) {

                    this.setState({
                        hasPresenceTicketType: this.state.presenceTicketType !== 0
                    });

                    validAllowance = (this.state.presenceTicketType !== 0);

                    if(!validAllowance) {
                        return;
                    }
                    else {
                        allowance.allowancePresenceTicket = { 
                            meetingId: this.state.selectedMeeting.code, 
                            presenceTicketType: this.state.presenceTicketType 
                        };
                    }
                }
                else {
                    this.setState({
                        hasTravelType: this.state.travelType.key !== 0
                    });

                    validAllowance = (this.state.travelType.key !== 0);

                    if(!validAllowance) {
                        return;
                    }
                    else {
                        this.setState({
                            //hasHotelOrMeal: this.state.travelType.key === 1 || (this.state.hasHotel || this.state.hasMeal),
                            hasMealNumber: !this.state.hasMeal || this.state.mealNumber !== "",
                            //hasHotelName: !this.state.hasHotel || (this.state.hotelName !== ""),
                            //hasHotelStars: !this.state.hasHotel || (this.state.hotelStars !== ""),
                            //hasHotelPrice: !this.state.hasHotel || (this.state.hotelPrice !== ""),
                            //hasHotelPhone: !this.state.hasHotel || (this.state.hotelPhone !== ""),
                            hasStartPeriodDate: this.state.travelType.key !== 1 || this.state.startPeriodDate !== null,
                            hasStartPeriodHour: this.state.travelType.key !== 1 || this.state.startPeriodHour !== null,
                            hasReturnPeriodDate: this.state.travelType.key !== 1 || this.state.returnPeriodDate !== null,
                            hasReturnPeriodHour: this.state.travelType.key !== 1 || this.state.returnPeriodHour !== null,
                            validPeriodDates: this.state.travelType.key !== 1 || (this.state.startPeriodDate === null || this.state.returnPeriodDate === null || this.state.returnPeriodDate >= this.state.startPeriodDate),
                            //hasTransport: (this.state.busTravel || this.state.trainTravel || this.state.carTravel || this.state.taxiTravel || this.state.planeTravel),
                            hasBusStartValue: !this.state.busTravel || (this.state.busStartValue !== "" && !isNaN(this.state.busStartValue)),
                            hasBusEndValue: !this.state.busTravel || (this.state.busEndValue !== "" && !isNaN(this.state.busEndValue)),
                            hasTrainStartValue: !this.state.trainTravel || (this.state.trainStartValue !== "" && !isNaN(this.state.trainStartValue)),
                            hasTrainEndValue: !this.state.trainTravel || (this.state.trainEndValue !== "" && !isNaN(this.state.trainEndValue)),
                            hasCarPlate: !this.state.carTravel || (this.state.carPlate !== ""),
                            hasCarKm: !this.state.carTravel || (this.state.carKm !== ""),
                            hasTaxiStartValue: !this.state.taxiTravel || (this.state.taxiStartValue !== "" && !isNaN(this.state.taxiStartValue)),
                            hasTaxiEndValue: !this.state.taxiTravel || (this.state.taxiEndValue !== "" && !isNaN(this.state.taxiEndValue)),
                            hasPlaneStartValue: !this.state.planeTravel || (this.state.planeStartValue !== "" && !isNaN(this.state.planeStartValue)),
                            hasPlaneEndValue: !this.state.planeTravel || (this.state.planeEndValue !== "" && !isNaN(this.state.planeEndValue)),
                            validPeriod: validPeriod
                        });

                        validAllowance = (
                            //(this.state.travelType.key === 1 || (this.state.hasHotel || this.state.hasMeal)) &&
                            (!this.state.hasMeal || (this.state.mealNumber !== "")) &&
                            //(!this.state.hasHotel || (this.state.hotelName !== "")) &&
                            //(!this.state.hasHotel || (this.state.hotelStars !== "")) &&
                            //(!this.state.hasHotel || (this.state.hotelPrice !== "")) &&
                            //(!this.state.hasHotel || (this.state.hotelPhone !== "")) &&
                            (this.state.travelType.key !== 1 || this.state.startPeriodDate !== null) &&
                            (this.state.travelType.key !== 1 || this.state.startPeriodHour !== null) &&
                            (this.state.travelType.key !== 1 || this.state.returnPeriodDate !== null) &&
                            (this.state.travelType.key !== 1 || this.state.returnPeriodHour !== null) &&
                            (this.state.travelType.key !== 1 || (this.state.startPeriodDate === null || this.state.returnPeriodDate === null || this.state.returnPeriodDate >= this.state.startPeriodDate)) &&
                            //(this.state.busTravel || this.state.trainTravel || this.state.carTravel || this.state.taxiTravel || this.state.planeTravel) &&
                            (!this.state.busTravel || (this.state.busStartValue !== "" && !isNaN(this.state.busStartValue))) &&
                            (!this.state.busTravel || (this.state.busEndValue !== "" && !isNaN(this.state.busEndValue))) &&
                            (!this.state.trainTravel || (this.state.trainStartValue !== "" && !isNaN(this.state.trainStartValue))) &&
                            (!this.state.trainTravel || (this.state.trainEndValue !== "" && !isNaN(this.state.trainEndValue))) &&
                            (!this.state.carTravel || (this.state.carPlate !== "")) &&
                            (!this.state.carTravel || (this.state.carKm !== "")) &&
                            (!this.state.taxiTravel || (this.state.taxiStartValue !== "" && !isNaN(this.state.taxiStartValue))) &&
                            (!this.state.taxiTravel || (this.state.taxiEndValue !== "" && !isNaN(this.state.taxiEndValue))) &&
                            (!this.state.planeTravel || (this.state.planeStartValue !== "" && !isNaN(this.state.planeStartValue)))&&
                            (!this.state.planeTravel || (this.state.planeEndValue !== "" && !isNaN(this.state.planeEndValue)))
                        );

                        if(!validAllowance) {
                            return;
                        }
                        else {
                            let validPeriod = this.validateAllowancePeriod();

                            if(!validPeriod) {
                                this.setState({ validPeriod: false });
                                return;
                            }

                            let startPeriodDate = this.state.startPeriodDate !== null && this.state.startPeriodHour !== null ? 
                                                    getUTCDate(new Date(this.state.startPeriodDate.getFullYear(), 
                                                        this.state.startPeriodDate.getMonth(), 
                                                        this.state.startPeriodDate.getDate(), 
                                                        this.state.startPeriodHour.getHours(),
                                                        this.state.startPeriodHour.getMinutes(),
                                                        this.state.startPeriodHour.getSeconds(),
                                                        this.state.startPeriodHour.getMilliseconds())) 
                                                    : null;

                            let returnPeriodDate = this.state.returnPeriodDate !== null && this.state.returnPeriodHour !== null ?
                                                    getUTCDate(new Date(this.state.returnPeriodDate.getFullYear(), 
                                                        this.state.returnPeriodDate.getMonth(), 
                                                        this.state.returnPeriodDate.getDate(), 
                                                        this.state.returnPeriodHour.getHours(),
                                                        this.state.returnPeriodHour.getMinutes(),
                                                        this.state.returnPeriodHour.getSeconds(),
                                                        this.state.returnPeriodHour.getMilliseconds()))
                                                    : null;

                            allowance.allowanceTravelMealHotel = { 
                                region: this.state.allowanceRegion.code,
                                payment: this.state.travelType.key === 1,
                                returnExpenses: this.state.travelType.key === 2,
                                meal: this.state.hasMeal,
                                mealNumber: this.state.mealNumber !== "" ? this.state.mealNumber : null,
                                hotel: this.state.hasHotel,
                                hotelName: this.state.hotelName,
                                numStars: this.state.hotelStars !== "" ? Number(this.state.hotelStars) : null,
                                dailyPrice: this.state.hotelPrice ? Number(this.state.hotelPrice) : null,
                                telephoneNumber: this.state.hotelPhone,
                                beginDate: startPeriodDate,
                                endDate: returnPeriodDate,
                                bus: this.state.busTravel,
                                busPrice: this.state.busStartValue ? Number(this.state.busStartValue) : null,   
                                busReturnPrice: this.state.busEndValue ? Number(this.state.busEndValue) : null,
                                train: this.state.trainTravel,
                                trainPrice: this.state.trainStartValue ? Number(this.state.trainStartValue) : null,
                                trainReturnPrice: this.state.trainEndValue ? Number(this.state.trainEndValue) : null,
                                car: this.state.carTravel,
                                carPlate: this.state.carPlate,
                                carKms: this.state.carKm !== "" ? Number(this.state.carKm) : null,
                                taxi: this.state.taxiTravel,
                                taxiPrice: this.state.taxiStartValue ? Number(this.state.taxiStartValue) : null,
                                taxiReturnPrice: this.state.taxiEndValue ? Number(this.state.taxiEndValue) : null,
                                plane: this.state.planeTravel,
                                planePrice: this.state.planeStartValue ? Number(this.state.planeStartValue) : null,
                                planeReturnPrice: this.state.planeEndValue !== "" ? Number(this.state.planeEndValue) : null,
                            };
                        }
                    }
                }

                if(validAllowance) {
                    if(this.props.creationMode) {
                        AllowanceService.createAllowance(allowance)
                        .then((response) => { 
                            this._toast.current.show({ severity: 'success', detail: this.props.t("allowances.messages.success"), life: 5000 });

                            // clear old selected meeting
                            this.setState({
                                selectedMeeting: null
                            });

                            // hide modal
                            this.props.onClose();
                        })
                        .catch(error => {
                            this._toast.current.show({ severity: 'error', detail: this.props.t("allowances.messages.error"), life: 3000 });
                        });
                    }
                    else {
                        AllowanceService.updateAllowance(allowance)
                        .then((response) => { 
                            this._toast.current.show({ severity: 'success', detail: this.props.t("allowances.messages.success-update"), life: 5000 });

                            // hide modal
                            this.props.onClose();
                        })
                        .catch(error => {
                            this._toast.current.show({ severity: 'error', detail: this.props.t("allowances.messages.error-update"), life: 3000 });
                        });
                    }
                }
            }
        }
    }

    validateAllowancePeriod() {
        let validPeriod = true;

        for (let i = 0; i < this.props.allowances.length; i++) {
            if(this.props.allowances[i].allowanceStateId !== ALLOWANCE_NOT_APPROVED && this.props.allowances[i].allowanceTravelMealHotel !== null) {
                if(this.state.beginDate.getTime() < Date.parse(this.props.allowances[i].eventBeginDate) && 
                    this.state.endDate.getTime() < Date.parse(this.props.allowances[i].eventBeginDate)) {  }
                else if(this.state.beginDate.getTime() > Date.parse(this.props.allowances[i].eventEndDate) && 
                this.state.endDate.getTime() > Date.parse(this.props.allowances[i].eventEndDate)) {   }
                else {
                    if(this.props.selectedAllowance !== null && this.props.selectedAllowance.allowanceRef === this.props.allowances[i].allowanceRef) return true;
                    
                    return false;                
                }
            }
        }

        return validPeriod;
    }

    getPersonalAddress() {
        var address = "";

        if(this.props.associate.personalData.streetTypePlaceholder !== null) {
            address += this.props.associate.personalData.streetTypePlaceholder;
        }

        if(this.props.associate.personalData.addressLine !== null) {
            address += " " + this.props.associate.personalData.addressLine;
        }

        if(this.props.associate.personalData.doorNumber !== null) {
            address += " " + this.props.associate.personalData.doorNumber;
        }

        if(this.props.associate.personalData.doorFloor !== null) {
            address += " " + this.props.associate.personalData.doorFloor;
        }

        return address;
    }

    updateTotalKm(kms) {
        this.setState({
            carKm: kms,
            carTotal: kms !== "" ? (kms * UNIT_KM_VALUE).toFixed(2) : null
        });
    }

    updateHotelTotal(hotelNightPrice) {

        if(this.state.beginDate !== null && this.state.endDate !== null) {
            this.setState({
                hotelPrice: hotelNightPrice,
                hotelTotal: dayDiff(this.state.beginDate, this.state.endDate) > 0 ? Number(hotelNightPrice) * dayDiff(this.state.beginDate, this.state.endDate) : null
            });
        }
        else  {
            this.setState({
                hotelPrice: hotelNightPrice,
                hotelTotal: null
            });
        }
    }

    render() {
        return (
            <div>
                <Steps model={this.state.dialogSteps} activeIndex={this.state.dialogActiveIndex} readOnly={true} />
                {
                    this.state.dialogActiveIndex === 0 ?
                        <div className="grid mgt-20">
                            <div className="col-12 lg:col-6">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="organic-unit">{this.props.t("allowances.dialog.common.form.organic-unit")}</label>
                                    {
                                        this.props.creationMode &&  this.props.organicUnits.length > 1 ?
                                        <Dropdown id="organic-unit" disabled={!this.props.creationMode} value={this.state.selectedOrganicUnitOption} options={this.getOrganicUnitList()} optionLabel="name" onChange={(evt) => this.selectOrganicUnit(evt.value)}></Dropdown>
                                        :
                                        <InputText disabled value={this.state.selectedOrganicUnit ? this.state.selectedOrganicUnit.name : null} id="organic-unit" type="text"/>
                                    }
                                    { this.state.hasOrganicUnit ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                </div>
                            </div>
                            <div className="col-12 lg:col-6">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="organic-unit-responsible">{this.props.t("allowances.dialog.common.form.organic-unit-responsible")}</label>
                                    <InputText disabled value={this.state.selectedOrganicUnit ? this.state.selectedOrganicUnit.responsible : null} id="organic-unit-responsible" type="text"/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="organic-unit-role">{this.props.t("allowances.dialog.common.form.organic-unit-role")}</label>
                                    <InputText disabled value={this.state.selectedOrganicUnit ? this.state.selectedOrganicUnit.associateRole : null} id="organic-unit-role" type="text"/>
                                </div>
                            </div>
                            {
                                this.props.selectedAllowanceType === ALLOWANCE_TYPE_MEAL_TRAVEL ?
                                    <div className="col-12">
                                        <Checkbox inputId="representation" onChange={e => this.setState({ representation: e.checked })} checked={this.state.representation}></Checkbox>
                                        <label htmlFor="representation" className="mgt-5 ml-2">{this.props.t("allowances.dialog.common.form.representation")}</label>
                                    </div>
                                    : null
                            }
                        </div>
                        : null  
                }
                {
                    this.state.dialogActiveIndex === 1 ?
                        <div className="grid mgt-20">
                            <div className="col-12 lg:col-8">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="name">{this.props.t("allowances.dialog.common.form.name")}</label>
                                    <InputText disabled value={this.props.associate.personalData.name} id="name" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="ballot">{this.props.t("allowances.dialog.common.form.ballot")}</label>
                                    <InputText disabled value={this.props.ballot !== null ? this.props.ballot.ballotRef : null} id="ballot" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="fiscalNumber">{this.props.t("allowances.dialog.common.form.fiscal-number")}</label>
                                    <InputText disabled value={this.props.associate.personalData.nif} id="fiscalNumber" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="niss">{this.props.t("allowances.dialog.common.form.niss")}</label>
                                    <InputText disabled value={this.props.associate.personalData.niss} id="niss" type="text" />
                                    { this.state.hasNiss ? null : <small className="p-error">{this.props.t("allowances.dialog.invalid-niss")}</small>  }
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="iban">{this.props.t("allowances.dialog.common.form.iban")}</label>
                                    <InputText disabled={!this.props.creationMode} value={this.state.iban} id="iban" type="text" onChange={(evt) => this.setState({iban: evt.target.value})} />
                                    { this.state.hasIban ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    { this.state.validIban ? null : <p><small className="p-error">{this.props.t("quotes.dialog.invalid-nib")}</small></p>  }
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="address">{this.props.t("allowances.dialog.common.form.address")}</label>
                                    {
                                        this.props.associate.professionalData !== undefined ? 
                                            <InputText disabled value={this.props.associate.professionalData.fullAddress + " " + this.props.associate.professionalData.cP4 + "-" + this.props.associate.professionalData.cP3 + " " + this.props.associate.professionalData.city} id="address" type="text" />
                                            :
                                            <InputText disabled value={this.getPersonalAddress() + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city} id="address" type="text" />
                                    }
                                </div>
                            </div>
                        </div>
                    : null
                }
                {
                    this.state.dialogActiveIndex === 2 ?
                        <div className="grid mgt-20">
                            <div className="col-12">
                                <label><b>{this.props.t("allowances.dialog.common.form.meeting-title")}</b></label>
                            </div>
                            {
                                this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET ?
                                    <>
                                        <div className="col-12 lg:col-6">
                                            <div className="flex flex-column gap-2">
                                                <label htmlFor="meeting">{this.props.t("allowances.dialog.common.form.meeting")}</label>
                                                <Dropdown id="meeting" value={this.state.selectedMeeting} options={this.getMeetingList()} optionLabel="name" onChange={(evt) => this.selectMeeting(evt.value)}></Dropdown>
                                                { this.state.hasMeeting ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-6"></div>
                                    </>
                                    : null
                            }
                            {
                                (this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET && this.state.selectedMeeting !== null) ?
                                    <>
                                        <div className="col-12 lg:col-4">
                                            <div className="flex flex-column gap-2">
                                                <label htmlFor="place">{this.props.t("allowances.dialog.common.form.place")}</label>
                                                <InputText maxLength={100} disabled={this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET} value={this.state.place} id="place" type="text" onChange={(evt) => this.setState({place: evt.target.value})} />
                                                { this.state.hasPlace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-4">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="begin-date">{this.props.t("allowances.dialog.common.form.begin-date")}</label>
                                                <Calendar id="begin-date" disabled={this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET} dateFormat="dd/mm/yy" value={this.state.beginDate} showIcon showButtonBar  onChange={(evt) => this.setState({ beginDate: evt.value })}/>
                                                { this.state.hasBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                { this.state.validDates ? null : <small className="p-error">{this.props.t("general.invalid-dates")}</small>  }
                                                { this.state.validLastYearProcess ? null : <small className="p-error">{this.props.t("allowances.dialog.common.form.invalid-last-year-process")}</small>  }
                                                { this.state.validDelayedProcess ? null : <small className="p-error">{this.props.t("allowances.dialog.common.form.invalid-delayed-process").replace("{0}", ALLOWANCE_REQUEST_MAX_DAYS)}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-4">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="end-date">{this.props.t("allowances.dialog.common.form.end-date")}</label>
                                                <Calendar id="end-date" disabled={this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET} dateFormat="dd/mm/yy" value={this.state.endDate} showIcon showButtonBar onChange={(evt) => this.setState({ endDate: evt.value })}/>
                                                { this.state.hasEndDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="reason">{this.props.t("allowances.dialog.common.form.reason")}</label>
                                                <InputText maxLength={100} disabled={this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET} value={this.state.reason} id="reason" type="text" onChange={(evt) => this.setState({reason: evt.target.value})} />
                                                { this.state.hasReason ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                    </>
                                    : null
                            }
                            {
                                this.props.selectedAllowanceType === ALLOWANCE_TYPE_MEAL_TRAVEL ?
                                    <>
                                        <div className="col-12 lg:col-12">
                                            <div className="flex flex-column gap-2">
                                                <label htmlFor="departure-place">{this.props.t("allowances.dialog.common.form.departure-place")}</label>
                                                <InputText maxLength={50} value={this.state.departurePlace} id="departure-place" type="text" onChange={(evt) => this.setState({departurePlace: evt.target.value})} />
                                                { this.state.hasDeparturePlace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        {
                                            this.state.hasCheckpoint ?
                                            <>
                                                <div className="col-12 lg:col-12">
                                                    <div className="flex flex-column gap-2">
                                                        <label htmlFor="checkpoint-place">{this.props.t("allowances.dialog.common.form.checkpoint-place")}</label>
                                                        <InputText maxLength={50} value={this.state.checkpointPlace} id="checkpoint-place" type="text" onChange={(evt) => this.setState({checkpointPlace: evt.target.value})}/>
                                                    </div>
                                                </div>
                                            </>
                                            : 
                                            null
                                        }
                                        <div className="col-12 lg:col-12">
                                            <div className="flex flex-column gap-2">
                                                <label htmlFor="place">{this.props.t("allowances.dialog.common.form.place")}</label>
                                                <InputText maxLength={50} value={this.state.place} id="place" type="text" onChange={(evt) => this.setState({place: evt.target.value})} />
                                                { this.state.hasPlace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        {
                                            !this.state.hasCheckpoint ?
                                                <>
                                                    <div className="col-8 mgt-10"></div>
                                                    <div className="col-4 mgt-10 t-align-right">
                                                        <div className="flex flex-column gap-2">
                                                        <Button label={this.props.t("allowances.dialog.common.form.add-checkpoint")} onClick={() => this.setState({hasCheckpoint: true})} />                                                    </div>
                                                    </div>
                                                </>
                                            : 
                                            null
                                        }
                                        
                                        <div className="col-12 lg:col-4">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="begin-date">{this.props.t("allowances.dialog.common.form.begin-date")}</label>
                                                <Calendar id="begin-date" dateFormat="dd/mm/yy" value={this.state.beginDate} showIcon showButtonBar onChange={(evt) => this.setState({ beginDate: evt.value, startPeriodDate: evt.value })}/>
                                                { this.state.hasBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                { this.state.validDates ? null : <small className="p-error">{this.props.t("general.invalid-dates")}</small>  }
                                                { this.state.validPeriod ? null : <small className="p-error">{this.props.t("allowances.dialog.common.form.invalid-period")}</small>  }
                                                { this.state.validLastYearProcess ? null : <small className="p-error">{this.props.t("allowances.dialog.common.form.invalid-last-year-process")}</small>  }
                                                { this.state.validDelayedProcess ? null : <small className="p-error">{this.props.t("allowances.dialog.common.form.invalid-delayed-process").replace("{0}", ALLOWANCE_REQUEST_MAX_DAYS)}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-4">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="end-date">{this.props.t("allowances.dialog.common.form.end-date")}</label>
                                                <Calendar id="end-date" dateFormat="dd/mm/yy" value={this.state.endDate} showIcon showButtonBar onChange={(evt) => this.setState({ endDate: evt.value, returnPeriodDate: evt.value })}/>
                                                { this.state.hasEndDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-4">
                                            <label htmlFor="allowance-region">{this.props.t("allowances.dialog.daily.region")}</label>
                                            <Dropdown className="w-full mgt-7" id="allowance-region" value={this.state.allowanceRegion} options={ALLOWANCE_REGIONS} optionLabel="name" onChange={(evt) => this.setState({ allowanceRegion: evt.value })}></Dropdown>
                                        </div>
                                        <div className="col-12">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="reason">{this.props.t("allowances.dialog.common.form.reason")}</label>
                                                <InputText maxLength={100} disabled={this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET} value={this.state.reason} id="reason" type="text" onChange={(evt) => this.setState({reason: evt.target.value})} />
                                                { this.state.hasReason ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                    </>
                                : null    
                            }
                            {
                                this.props.selectedAllowanceType === ALLOWANCE_TYPE_PRESENCE_TICKET ? 
                                    <>
                                        <div className="col-12 mgt-10">
                                            <label><b>{this.props.t("allowances.dialog.presence-tickets.type-title-1")}</b></label>
                                        </div>
                                        <div className="col-12">
                                            <label>{this.props.t("allowances.dialog.presence-tickets.type-title-2")}</label>
                                        </div>
                                        <div className="col-12">
                                            {this.getPresenceTicketTypes().map((presenceTicketType) => {
                                                return (
                                                    <div key={presenceTicketType.key} className="flex">
                                                        <RadioButton disabled inputId={presenceTicketType.key} className='mgt-5' name="presenceTicketType" value={presenceTicketType} checked={this.state.presenceTicketType === presenceTicketType.key} />
                                                        <label htmlFor={presenceTicketType.key} className="mgt-5 ml-2">{presenceTicketType.name}</label>
                                                    </div>
                                                );
                                            })}
                                            { this.state.hasPresenceTicketType ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        <div className="col-12">
                                            <label>{this.props.t("allowances.dialog.presence-tickets.type-nb")}</label>
                                        </div>
                                    </>
                                    : null
                            }
                            {
                                this.props.selectedAllowanceType !== ALLOWANCE_TYPE_PRESENCE_TICKET ? 
                                    <>
                                        <div className="col-12 mgt-10">
                                            <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.need")}</b></label>
                                        </div>
                                        <div className="col-12">
                                            {this.state.travelTypes.map((travelType) => {
                                                return ( !travelType.disabled ?
                                                    <>
                                                    <div key={travelType.key} className="flex">
                                                        <RadioButton inputId={travelType.key} className='mgt-5' name="travelType" value={travelType} disabled={travelType.disabled} onChange={(evt) => this.setState({ travelType: evt.value })} checked={this.state.travelType.key === travelType.key} />
                                                        <label htmlFor={travelType.key} className="mgt-5 ml-2">{travelType.name}</label>
                                                    </div>
                                                    <div key={travelType.key + "-1"} className="flex">
                                                        <label className="mgt-5 pl-25"><b>{travelType.description}</b></label>
                                                    </div>
                                                    </>
                                                    : null
                                                );
                                            })}
                                            { this.state.hasTravelType ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        {
                                            this.state.travelType !== null && this.state.travelType.key === 2 ?
                                                <>
                                                    <div className="col-12 mgt-10">
                                                        <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.type-meal-hotel")}</b></label>
                                                    </div>
                                                    <div className="col-12 lg:col-6">
                                                        <Checkbox inputId="cb-hotel" onChange={e => this.setState({ hasHotel: e.checked })} checked={this.state.hasHotel}></Checkbox>
                                                        <label htmlFor="hasHotel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.hotel")}</label>
                                                    </div>
                                                    <div className="col-12 lg:col-6"></div>
                                                    {
                                                        this.state.hasHotel ?
                                                        <>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="hotel-name">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-name")}</label>
                                                                    <InputText maxLength={50} value={this.state.hotelName} id="bus-start" type="text" onChange={(evt) => this.setState({hotelName: evt.target.value})} />
                                                                    { /* this.state.hasHotelName ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  */}
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-2">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="hotel-stars">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-stars")}</label>
                                                                    <InputText maxLength={1} pattern="\d*" value={this.state.hotelStars} id="hotel-stars" type="text" onChange={(evt) => this.setState({hotelStars: evt.target.value})} />
                                                                    { /* this.state.hasHotelStars ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> */ }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-2">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="hotel-price">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.hotelPrice} id="hotel-price" type="text" onChange={(evt) => this.updateHotelTotal(evt.target.value)} />
                                                                    { /* this.state.hasHotelPrice ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> */ }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="hotel-total">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-total")}</label>
                                                                    <InputText disabled maxLength={8} pattern="\d*" value={this.state.hotelTotal} id="hotel-total" type="text" />
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-2">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="hotel-phone">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-phone")}</label>
                                                                    <InputText maxLength={15} pattern="\d*" value={this.state.hotelPhone} id="hotel-phone" type="text" onChange={(evt) => this.setState({hotelPhone: evt.target.value})} />
                                                                    { /* this.state.hasHotelPhone ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small> */ }
                                                                </div>
                                                            </div>
                                                        </>
                                                        : null
                                                    }
                                                    <div className="col-12 lg:col-12">
                                                        <Checkbox inputId="cb-meal" onChange={e => this.setState({ hasMeal: e.checked })} checked={this.state.hasMeal}></Checkbox>
                                                        <label htmlFor="hasMeal" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.meal")}</label>
                                                    </div>
                                                    {/* !this.state.hasHotelOrMeal ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null */}
                                                    {
                                                        this.state.hasMeal ? 
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="meal-number">{this.props.t("allowances.dialog.travel-hotel-meal.meal-number")}</label>
                                                                    <InputText maxLength={2} pattern="\d*" value={this.state.mealNumber} id="meal-number" type="text" onChange={(evt) => this.setState({mealNumber: evt.target.value})} />
                                                                    { this.state.hasMealNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            : null
                                                    }
                                                </>
                                                : null
                                        }
                                        {
                                            this.state.travelType.key !== 0 ?
                                                <div className="col-12 mgt-10">
                                                    <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.type-travel")}</b></label>
                                                </div>
                                                : null
                                        }
                                        {
                                            this.state.travelType.key === 1 ? 
                                            <>
                                                <div className="col-12 lg:col-3">
                                                    <div className="flex flex-column gap-2">
                                                        <label className='mgr-10' htmlFor="start-period-date">{this.props.t("allowances.dialog.travel-hotel-meal.start-period")}</label>
                                                        <Calendar id="start-period-date" dateFormat="dd/mm/yy" value={this.state.startPeriodDate} showIcon showButtonBar onChange={(evt) => this.setState({ startPeriodDate: evt.value })}/>
                                                        { this.state.hasStartPeriodDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                        { this.state.validPeriodDates ? null : <small className="p-error">{this.props.t("general.invalid-dates")}</small>  }
                                                    </div>
                                                </div>
                                                <div className="col-12 lg:col-3">
                                                    <div className="flex flex-column gap-2">
                                                        <label className='mgr-10' htmlFor="start-period-hour">{this.props.t("allowances.dialog.travel-hotel-meal.start-hour")}</label>
                                                        <Calendar id="start-period-hour" value={this.state.startPeriodHour} onChange={(evt) => this.setState({ startPeriodHour: evt.value })} showIcon timeOnly  icon={() => <i className="pi pi-clock" />} />
                                                        { this.state.hasStartPeriodHour ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                </div>
                                                <div className="col-12 lg:col-3">
                                                    <div className="flex flex-column gap-2">
                                                        <label className='mgr-10' htmlFor="return-period-date">{this.props.t("allowances.dialog.travel-hotel-meal.return-period")}</label>
                                                        <Calendar id="return-period-date" dateFormat="dd/mm/yy" value={this.state.returnPeriodDate} showIcon showButtonBar onChange={(evt) => this.setState({ returnPeriodDate: evt.value })}/>
                                                        { this.state.hasReturnPeriodDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                </div>
                                                <div className="col-12 lg:col-3">
                                                    <div className="flex flex-column gap-2">
                                                        <label className='mgr-10' htmlFor="return-period-hour">{this.props.t("allowances.dialog.travel-hotel-meal.return-hour")}</label>
                                                        <Calendar id="return-period-hour" value={this.state.returnPeriodHour} onChange={(evt) => this.setState({ returnPeriodHour: evt.value })} showIcon timeOnly  icon={() => <i className="pi pi-clock" />} />
                                                        { this.state.hasReturnPeriodHour ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                </div>
                                            </> : null
                                        }
                                        {
                                            this.state.travelType.key !== 0 ?
                                                <>
                                                    <div className="col-12">
                                                        <Checkbox inputId="cb-bus-travel" onChange={e => this.setState({ busTravel: e.checked })} checked={this.state.busTravel}></Checkbox>
                                                        <label htmlFor="busTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.bus")}</label>
                                                    </div>
                                                    {
                                                        this.state.busTravel ?
                                                        <>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.busStartValue} id="bus-start" type="text" onChange={(evt) => this.setState({busStartValue: evt.target.value})} />
                                                                    { this.state.hasBusStartValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.busEndValue} id="bus-end" type="text" onChange={(evt) => this.setState({busEndValue: evt.target.value})} />
                                                                    { this.state.hasBusEndValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-6"></div>
                                                        </>
                                                        : 
                                                        null
                                                    }
                                                    <div className="col-12">
                                                        <Checkbox inputId="cb-train-travel" onChange={e => this.setState({ trainTravel: e.checked })} checked={this.state.trainTravel}></Checkbox>
                                                        <label htmlFor="trainTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.train")}</label>
                                                    </div>
                                                    {
                                                        this.state.trainTravel ?
                                                        <>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.trainStartValue} id="bus-start" type="text" onChange={(evt) => this.setState({trainStartValue: evt.target.value})} />
                                                                    { this.state.hasTrainStartValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.trainEndValue} id="bus-end" type="text" onChange={(evt) => this.setState({trainEndValue: evt.target.value})} />
                                                                    { this.state.hasTrainEndValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-6"></div>
                                                        </>
                                                        : 
                                                        null
                                                    }
                                                    <div className="col-12">
                                                        <Checkbox inputId="cb-car-travel" onChange={e => this.setState({ carTravel: e.checked })} checked={this.state.carTravel}></Checkbox>
                                                        <label htmlFor="carTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.car")}</label>
                                                    </div>
                                                    {
                                                        this.state.carTravel ?
                                                        <>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="car-plate">{this.props.t("allowances.dialog.travel-hotel-meal.car-plate")}</label>
                                                                    <InputText maxLength={10} value={this.state.carPlate} id="car-plate" type="text" onChange={(evt) => this.setState({carPlate: evt.target.value})} />
                                                                    { this.state.hasCarPlate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-4">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="car-km">{this.props.t("allowances.dialog.travel-hotel-meal.car-km")}</label>
                                                                    <InputText maxLength={3} pattern="\d*" value={this.state.carKm} id="car-km" type="text" onChange={(evt) => this.updateTotalKm(evt.target.value)} />
                                                                    { this.state.hasCarKm ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="car-total">{this.props.t("allowances.dialog.expenses.car-total")}</label>
                                                                    <InputText disabled maxLength={6} pattern="\d*" value={this.state.carTotal} id="car-total" type="text" />
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-2"></div>
                                                        </>
                                                        : 
                                                        null
                                                    }
                                                    <div className="col-12">
                                                        <Checkbox inputId="cb-taxi-travel" onChange={e => this.setState({ taxiTravel: e.checked })} checked={this.state.taxiTravel}></Checkbox>
                                                        <label htmlFor="taxiTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.taxi")}</label>
                                                    </div>
                                                    {
                                                        this.state.taxiTravel ?
                                                        <>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.taxiStartValue} id="bus-start" type="text" onChange={(evt) => this.setState({taxiStartValue: evt.target.value})} />
                                                                    { this.state.hasTaxiStartValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.taxiEndValue} id="bus-end" type="text" onChange={(evt) => this.setState({taxiEndValue: evt.target.value})} />
                                                                    { this.state.hasTaxiEndValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-6"></div>
                                                        </>
                                                        : 
                                                        null
                                                    }
                                                    <div className="col-12">
                                                        <Checkbox inputId="cb-plane-travel" onChange={e => this.setState({ planeTravel: e.checked })} checked={this.state.planeTravel}></Checkbox>
                                                        <label htmlFor="planeTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.plane")}</label>
                                                    </div>
                                                    {
                                                        this.state.planeTravel ?
                                                        <>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.planeStartValue} id="bus-start" type="text" onChange={(evt) => this.setState({planeStartValue: evt.target.value})} />
                                                                    { this.state.hasPlaneStartValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-3">
                                                                <div className="flex flex-column gap-2">
                                                                    <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                                                    <InputText maxLength={8} pattern="\d*" value={this.state.planeEndValue} id="bus-end" type="text" onChange={(evt) => this.setState({planeEndValue: evt.target.value})} />
                                                                    { this.state.hasPlaneEndValue ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 lg:col-6"></div>
                                                        </>
                                                        : 
                                                        null
                                                    }
                                                    { /* !this.state.hasTransport ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null */ }
                                                </>
                                                : null
                                        }
                                        <div className="col-12 mgt-10">
                                            <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.observations")}</b></label>
                                        </div>
                                        <div className="col-12">
                                            <InputTextarea style={{width:"100%"}} value={this.state.observations} id="observations" type="text" onChange={(evt) => this.setState({observations: evt.target.value})} />
                                        </div>
                                    </>
                                    : null
                            }
                        </div>
                    : null
                }
                <div className="grid mgt-20">
                    <div className="col-6 t-align-left mgt-10">
                        {
                            this.state.dialogActiveIndex !== 0 ? <Button className='p-button-danger' label={this.props.t("general.back")} onClick={() => this.updateDialogActiveIndex((this.state.dialogActiveIndex-1))} /> : null
                        }
                    </div> 
                    <div className="col-6 t-align-right mgt-10">
                        {
                            this.state.dialogActiveIndex !== 2 ? <Button label={this.props.t("general.next")} onClick={() => this.validateFormAndSubmitStep()}/> : null
                        }
                        {
                            this.state.dialogActiveIndex === 2 ? <Button className='p-button-success' label={this.props.t("general.confirm")} onClick={() => this.validateFormAndSubmitStep()} /> : null
                        }
                    </div> 
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
    }
}

export default withTranslation(AllowanceCreationComponent);